import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Checkbox from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Checkbox';
import { FormControlLabel } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

const CustomCheckBox = withStyles(theme => ({
  root: {
    color: theme.palette.facet.accentBlue21,
    '&:not($checked) .MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
    '&$checked': {
      color: theme.palette.facet.primaryBlue,
    },
    '&$checked .MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
    '&.MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
  },
  checked: {},
}))((props) => <Checkbox {...props} />);

// CheckboxStandardized Styles
const styles = (theme) => ({
  root: {},
  formControlLabel: {
    color: theme.palette.facet.primaryBlue,
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
  },
});

const CheckboxStandardized = ({
  className,
  classes,
  hidden,
  label,
  value,
  helperText,
  ...rest
}) => {
  return (
    <FormControlLabel
      label={label}
      className={classNames(classes.root, className)}
      classes={{
        label: classes.formControlLabel,
      }}
      control={
        <CustomCheckBox
          className={classes.checkbox}
          variant={'outlined'}
          checked={value}
          checkedIcon={<CheckIcon />}
          {...rest}
        />
      }
      hidden={hidden}
    />
  );
};

CheckboxStandardized.defaultProps = {
  className: '',
  label: null,
};

CheckboxStandardized.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default withStyles(styles, { name: 'Checkbox' })(CheckboxStandardized);
